import { useIntl, FormattedMessage } from "react-intl";
import useAssetReturn from "../../actions/explore/return/useAssetReturn";
import useExploreFetcher from "../../actions/explore/useExploreFetcher";
import LoaderButton from "../../../../common/core-ui/LoaderButton";
import { useEffect } from "react";

export default function ReturnButton({
  asset,
  className,
  onReturn,
}: {
  asset: VST.Bridge.Asset;
  className: string;
  onReturn?: () => void;
}) {
  const intl = useIntl();
  const returnAsset = useAssetReturn(asset);
  const { activeFetcher, returnComplete, returnError } =
    useExploreFetcher(asset);

  useEffect(() => {
    if (returnComplete || returnError) {
      onReturn?.();
    }
  }, [returnComplete, returnError, onReturn]);

  return (
    <LoaderButton
      className={className}
      aria-label={intl.formatMessage(
        {
          defaultMessage: "Return {title}",
        },
        { title: asset.title }
      )}
      onClick={returnAsset}
      // There is a very quick delay between the action completing and the asset data updating, so
      // keep the button in loading state once the action completes until the data is updated.
      loading={activeFetcher?.state === "submitting" || !!returnComplete}
      loaderProps={{ color: "thematic" }}
    >
      <FormattedMessage defaultMessage="Return" />
    </LoaderButton>
  );
}
